<template>
  <div ref="pointRef" style="overflow: auto;">
    <el-form
      ref="rowForm"
      :model="rowData"
      :label-width="labelWidth"
      class="demo-ruleForm"
      :rules="rules"
      :validate-on-rule-change="false"
    >
      <el-form-item label="类型:">
        <span>{{ rowForm.typeNames }}</span>
        <!-- <el-input  v-model="rowForm.typeNames" :disabled="pageFlag === 3"></el-input> -->
      </el-form-item>

      <el-form-item label="图片:">
        <div class="img-wrapper">
          <div class="img-block" v-for="(url, index) in rowForm.recycleImages" :key="index">
            <el-image
              style="width: 100%; height: 100%"
              :src="url"
              :preview-src-list="rowForm.recycleImages"
              :fit="cover"/>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="收货图片:" v-if="pageFlag!= 1">
        <el-upload
          ref="upload"
          multiple
          :limit="5"
          v-if="pageFlag === 2"
          name="files"
          class="avatar-uploader"
          :action="uploadAction"
          accept=".png, .jpg, jpeg"
          :show-file-list="true"
          :file-list="fileList"
          :headers="{ Authorization: token }"
          :on-change="uploadChange"
          :on-remove="removeFile"
          :auto-upload="false"
          list-type="picture-card"
          >
          <i class="el-icon-plus avatar-uploader-icon"/>
          <div slot="tip" class="el-upload__tip">最多上传5张</div>
        </el-upload>

        <div class="img-wrapper">
          <div class="img-block" v-for="(url, index) in rowData.receiveImages" :key="index">
              <el-image
                style="width: 100%; height: 100%"
                :src="url"
                :preview-src-list="rowData.receiveImages"
                :fit="cover"/>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="分值:" prop="pointNum" v-if="pageFlag !== 1">
        <span v-if="pageFlag === 3">{{ rowData.pointNum }}</span>
        <el-input v-else v-model.number="rowData.pointNum"  type="number" class="width" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Vue from 'vue'
import {pointOrder} from '@/api/recyclingForm'
export default {
  props: {
    rowForm: Object,
    pageFlag: [Number, String]
  },
  data () {
    const uploadAction = process.env.VUE_APP_BASE_API + '/qtSysapi/recycleOrder/point'
    const numLenCheck = (rule, val, callback) => {
      const value = val
      if (value > 10000 || value <= 0) {
        callback(new Error('数值在1至10000之间'))
      } else {
        callback()
      }
    }
    return {
      key: 1,
      uploadAction,
      cover: 'contain', // 图片适应方式
      rowData: {
        receiveImages: [],
        recycleImages: [],
        typeNames: '',
        pointNum: ''
      },
      fileList: [],
      labelWidth: '90px', // 默认标签宽度
      rules: {
        pointNum: [{ required: true, message: '请选择', trigger: 'blur' }, {validator: numLenCheck, trigger: 'blur'}]
      },
      upload: {
        fileList: [],
        fileName: []
      }
    }
  },
  computed: {
    token () {
      return Vue.cookie.get('Authorization')
    }
  },
  mounted () {
    if (this.rowForm) {
      this.rowData = this.rowForm
    }
  },
  methods: {
    removeFile (file, fileList) {
      this.fileList = fileList.map(item => item.url)
      this.upload.fileList = fileList
    },
    beforeAvatarUpload (file) {
      const isLtM = file.size < 2 * 1024 * 1024
      if (!isLtM) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLtM
    },
    uploadChange (event, fileList) {
      this.fileList = fileList
      this.upload.fileList = fileList
      this.changeModify()
    },
    changeModify () {
      this.$forceUpdate()
    },

    // 提交上传文件
    submitFileForm () {
      // 创建新的数据对象
      let formData = new FormData()
      // 将上传的文件放到数据对象中
      this.upload.fileList.forEach(file => {
        formData.append('files', file.raw)
        this.upload.fileName.push(file.name)
      })
      formData.append('recycleId', this.rowData.id)
      formData.append('point', this.rowData.pointNum)

      // 文件名
      formData.append('fileName', this.upload.fileName)
      // 自定义上传
      pointOrder(formData).then(response => {
          // if(response.code == 200){
          //   this.$refs.upload.clearFiles();
          //   this.msgSuccess('上传成功！');
          // }else{
          //   this.$message.error(response.msg);
          // }
      })
        .catch(() => {
          this.$message.error('上传失败！')
        })
    }

  }
}
</script>

<style lang="scss" scoped>
.width {
  width: 85%;
}
.img-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: start;
  align-items: center;
}
.img-block {
    display: flex;
    width: 100px;
    height: 100px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
.avatar-uploader {
  border-radius: 6px;
  cursor: pointer;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.el-upload__tip {
  font-size: 11px;
  color: #ddd;
  padding-left: 20px;
  margin-top: -10px;
}
::v-deep .el-upload.el-upload--picture-card{
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .el-icon-plus.avatar-uploader-icon{
    font-size: 28px;
    color: #8c939d;
  }
}
::v-deep .el-upload-list__item.is-ready{
  width: 100px;
  height: 100px;
  border-radius: 0;
}
</style>